import ModalCompanies from "./ModalCompanies";
import Swiper from "swiper/swiper-bundle";

class PortfolioComponent {
  constructor(el) {
    this.el = el;
    this.theme = this.el.getAttribute("data-portfolio-component");
    this.companiesRoot = this.el.querySelector("[data-companies-root]");
    this.enableReorder = this.companiesRoot?.getAttribute("data-enable-reorder") === "true";
    this.companies = Array.from(this.el.querySelectorAll("[data-company]"));
    this.components = Array.from(this.el.querySelectorAll("[data-component]"));
    this.filterInput = this.el.querySelector("#search");
    this.filters = Array.from(this.el.querySelectorAll("[data-filter]"));
    this.filterOptions = Array.from(
      this.el.querySelectorAll("[data-filter-option]")
    );
    this.clearSearchBtn = this.el.querySelector(".search-field__x");

    this.itemsPerRow = parseInt(this.companiesRoot?.getAttribute("data-items-per-row") || "10", 10);
    this.sequencePattern = JSON.parse(this.companiesRoot?.getAttribute("data-sequence-pattern") || "[0, 5, 1, 6, 2, 7, 3, 8, 4, 9]");
    this.filteredCompanies = [...this.companies];
    this.appliedFilters = {};
    this.initSliders();
    this.init();
    if(this.filters.length > 0) {
      this.filterCompanies();
    }
  }

  initSliderEnterprise() {
    this.swiper = new Swiper(".ent-logo-slider", {
      slidesPerView: 2,
      slidesPerGroup: 2,

      autoplay: {
        enabled: false,
        delay: 3500,
        disableOnInteraction: false,
      },
      grid: {
        rows: 5,
      },
      pagination: {
        el: ".ent-logo-slider .swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: ".ent-logo-slider .swiper-button-next",
        prevEl: ".ent-logo-slider .swiper-button-prev",
      },
    });
  }

  initGrowthSlider() {
    this.swiper = new Swiper(".growth-logo-slider", {
      slidesPerView: 2,
      slidesPerGroup: 2,

      grid: {
        rows: 5,
      },
      pagination: {
        el: ".growth-logo-slider .swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: ".growth-logo-slider .swiper-button-next",
        prevEl: ".growth-logo-slider .swiper-button-prev",
      },
    });
  }

  initInfraSlider() {
    this.swiper = new Swiper(".infra-grid-slider", {
      slidesPerView: 2,
      slidesPerGroup: 2,

      grid: {
        rows: 11,
      },

      pagination: {
        el: ".infra-grid-slider .swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: ".infra-grid-slider .swiper-button-next",
        prevEl: ".infra-grid-slider .swiper-button-prev",
      },
    });
  }

  initSliders() {
    const enterpriseEl = document.querySelector(".ent-logo-slider");
    const growthEl = document.querySelector(".growth-logo-slider");
    const infraEl = document.querySelector(".infra-grid-slider");
    if (enterpriseEl) {
      this.initSliderEnterprise();
    }
    if (growthEl) {
      this.initGrowthSlider();
    }
    if (infraEl) {
      this.initInfraSlider();
    }
  }

  sequenceNumber(num) {
    const pattern = this.sequencePattern;
    let leadingDigit;
    if (num >= pattern.length) {
      leadingDigit = Math.floor(num / pattern.length);
      return leadingDigit * pattern.length + pattern[num % pattern.length];
    }

    return pattern[num % pattern.length];
  }

  applyCellIndexToFilteredCompanies() {
    this.filteredCompanies.forEach((company, index) => {
      const sequenceNumber = this.sequenceNumber(index);
      company.style.setProperty("--cell-index", sequenceNumber);
    });
  }

  removeFillerItems() {
    const fillerItems = Array.from(
      this.companiesRoot?.querySelectorAll(".grid-item-filler")
    );
    if (fillerItems.length > 0) {
      fillerItems.forEach((item) => item.remove());
    }
  }

  updateCellFillers() {
    const fillerItemsCount = this.itemsPerRow - (this.filteredCompanies.length % this.itemsPerRow);
    
    if (fillerItemsCount > 0 && fillerItemsCount < this.itemsPerRow) {
      let lastSequencedIndex = this.filteredCompanies.length;
      for (let i = 0; i < fillerItemsCount; i++) {
        const sequenceNumber = this.sequenceNumber(lastSequencedIndex);
        const fillerItem = document.createElement("div");
        fillerItem.classList.add("grid-item");
        fillerItem.classList.add("swiper-slide");
        fillerItem.classList.add("grid-item-filler");
        fillerItem.style.setProperty("--cell-index", sequenceNumber);
        this.companiesRoot?.appendChild(fillerItem);
        lastSequencedIndex++;
      }
    }
  }

  init() {
    this.updateComponents();

    if (this.filterInput && this.clearSearchBtn) {
      this.filterInput.addEventListener("input", (event) => {
        requestAnimationFrame(() => this.filterCompaniesByText(event));
        if (this.filterInput.value.length > 0) {
          this.clearSearchBtn.style.display = "inline";
        } else {
          this.clearSearchBtn.style.display = "none";
        }
      });

      this.clearSearchBtn.addEventListener("click", () => {
        this.filterInput.value = "";
        this.clearSearchBtn.style.display = "none";
        this.filterCompaniesByText({ target: this.filterInput });
      });
    }

    this.filters.forEach((filter) => {
      const filterName = filter.getAttribute("data-filter");
      this.appliedFilters[filterName] = "";

      filter.addEventListener("click", (event) => {
        event.preventDefault();
        const dropdown = filter.querySelector(".select-drop");
        dropdown.classList.toggle("open");
      });
    });

    this.filterOptions.forEach((option) => {
      option.addEventListener("click", (event) => {
        event.preventDefault();

        const filterName = option
          .closest("[data-filter]")
          .getAttribute("data-filter");
        this.appliedFilters[filterName] =
          option.getAttribute("data-filter-option");
        this.filterCompanies();
      });
    });

    this.checkboxFilter = this.el.querySelector("[data-filter-checkbox]");
    if (this.checkboxFilter) {
      this.checkboxFilter.addEventListener("change", () => {
        this.filterCompanies();
      });
    }

    this.caseStudyInterval = setInterval(() => {
      const caseStudiesGroup = $(".banner-large");
      caseStudiesGroup.each(function (index) {
        const caseStudies = $(this).find(".box");
        if (caseStudies.length > 1) {
          const current = $(this).find(".box.active");
          const next = current.next();
          const nextIndex = next.index();
          current.removeClass("active");
          if (nextIndex === -1) {
            $(this).find(".box").first().addClass("active");
          } else {
            next.addClass("active");
          }
        }
      });
    }, 3000);

    ModalCompanies("[data-portfolio-component] [data-company]", this.theme);
  }

  isCompanyMatch(company, filterText) {
    const companyName = company.getAttribute("data-name").toLowerCase();
    let companySecondaryName = company.getAttribute("data-secondary-name");
    if (!companySecondaryName) {
      return companyName.includes(filterText);
    }
    companySecondaryName = companySecondaryName.toLowerCase();
    return (
      companyName.includes(filterText) ||
      companySecondaryName.includes(filterText)
    );
  }

  updateCompanyDisplayStyle(company, isMatch) {
    company.style.display = isMatch ? "" : "none";
    if (company.parentElement.classList.contains("swiper-wrapper")) {
      if (isMatch) {
        company.classList.remove("non-swiper-slide");
        company.classList.add("swiper-slide");
      } else {
        company.classList.remove("swiper-slide");
        company.classList.add("non-swiper-slide");
      }
    }
  }

  filterCompaniesByText({ target }) {
    const filterText = target.value.toLowerCase();
    this.filteredCompanies = this.companies.filter((company) => {
      const isMatch = this.isCompanyMatch(company, filterText);
      this.updateCompanyDisplayStyle(company, isMatch);
      return isMatch;
    });
    this.filterCompanies();
  }

  getJobsCount(company) {
    return this.filteredCompanies.reduce((acc, company) => {
      const numberOfJobs =
        parseInt(company.getAttribute("data-number-of-jobs"), 10) || 0;
      return acc + numberOfJobs;
    }, 0);
  }

  isFiltered() {
    return (
      Object.values(this.appliedFilters).some((filter) => filter !== "") ||
      this.filterInput.value !== ""
    );
  }

  filterCompanies() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }

    const filterAttributes = Object.entries(this.appliedFilters);
    this.el.classList.toggle("is-filtered", this.isFiltered());

    this.checkboxFilterMode = this.checkboxFilter
      ? this.checkboxFilter.getAttribute("data-filter-mode") || "default"
      : "default";

    this.filteredCompanies = this.companies.filter((company) => {
      const attributeMatches = filterAttributes.every(
        ([filterName, filterValue]) => {
          if (filterValue === "") {
            return true;
          }
          const companyAttributes = company
            .getAttribute("data-filter-by")
            .split(";");

          // Add prefix based on filter type
          const prefix = filterName === 'industry' ? 'ind_' :
                        filterName === 'stage' ? 'stg_' :
                        filterName === 'category' ? 'cat_' :
                        filterName === 'status' ? 'sts_' : '';
          
          const prefixedValue = prefix + filterValue.toLowerCase();
          
          return companyAttributes.some(
            (attribute) => attribute.toLowerCase() === prefixedValue
          );
        }
      );

      const textFilterMatches = this.filterInput
        ? this.isCompanyMatch(company, this.filterInput.value.toLowerCase())
        : true;

      const companyCheckboxAttributes = company.getAttribute(
        "data-filter-checkbox"
      )
        ? company.getAttribute("data-filter-checkbox").split(";")
        : [];

      let checkboxFilterMatches = true;
      switch (this.checkboxFilterMode) {
        case "toggle":
          checkboxFilterMatches = this.checkboxFilter.checked
            ? companyCheckboxAttributes.some(
                (attribute) =>
                  attribute.toLowerCase() ===
                  this.checkboxFilter
                    .getAttribute("data-filter-checkbox")
                    .toLowerCase()
              )
            : companyCheckboxAttributes.every(
                (attribute) =>
                  attribute.toLowerCase() !==
                  this.checkboxFilter
                    .getAttribute("data-filter-checkbox")
                    .toLowerCase()
              );
          break;
        default:
          checkboxFilterMatches =
            !this.checkboxFilter ||
            !this.checkboxFilter.checked ||
            companyCheckboxAttributes.some(
              (attribute) =>
                attribute.toLowerCase() ===
                this.checkboxFilter
                  .getAttribute("data-filter-checkbox")
                  .toLowerCase()
            );
          break;
      }

      const isMatch =
        attributeMatches && textFilterMatches && checkboxFilterMatches;
      this.updateCompanyDisplayStyle(company, isMatch);
      return isMatch;
    });

    if (this.enableReorder) {
      this.removeFillerItems();
      this.applyCellIndexToFilteredCompanies();
      this.updateCellFillers();
    }

    this.initSliders();
    this.updateComponents();
  }

  updateComponents() {
    let currentCompanyIndex = 0;
    let lastInsertedComponentIndex = 0;
    let companiesInGrid = this.companies.filter((company) =>
      company.classList.contains("grid-item")
    );
    let filteredCompaniesInGrid = this.filteredCompanies.filter((company) =>
      company.classList.contains("grid-item")
    );

    // if (this.filteredCompanies.length !== this.companies.length) {
    //     if(this.swiper) {
    //         this.swiper.destroy();
    //         this.swiper = null;
    //     }
    // }

    this.components.forEach((component) => {
      const titleElement = component.querySelector("[data-title]");
      if (titleElement) {
        this.updateTitleElement(titleElement);
      }

      if (this.filteredCompanies.length !== this.companies.length) {
        component.style.display = component.dataset.doNotHide ? "" : "none";

        if (component.dataset.doNotHide) {
          if (
            this.el.getAttribute("data-behavior-on-filter") ===
              "center-not-hidden" &&
            filteredCompaniesInGrid.length > 0
          ) {
            const middleIndex = Math.floor(filteredCompaniesInGrid.length / 2);
            filteredCompaniesInGrid[middleIndex].insertAdjacentElement(
              "beforebegin",
              component
            );
          } else {
            component.parentElement.appendChild(component);
          }
        } else {
          component.parentElement.appendChild(component);
        }
      } else {
        const showAfter = parseInt(
          component.getAttribute("data-show-after"),
          10
        );
        let targetIndex = lastInsertedComponentIndex + showAfter;

        while (
          targetIndex < companiesInGrid.length &&
          companiesInGrid[targetIndex].style.display === "none"
        ) {
          targetIndex++;
        }

        if (targetIndex < companiesInGrid.length) {
          companiesInGrid[targetIndex].insertAdjacentElement(
            "beforebegin",
            component
          );
          component.style.display = "";
          lastInsertedComponentIndex = targetIndex;
          currentCompanyIndex = targetIndex;
        } else {
          component.style.display = "none";
        }
      }

      if (component.dataset.doNotHide) {
        const jobsCount = this.getJobsCount();
        if (jobsCount === 0) {
          component.style.display = "none";
        }
        currentCompanyIndex++;
      }
    });
  }

  updateTitleElement(titleElement) {
    const companyCount = this.filteredCompanies.length;
    const jobsCount = this.getJobsCount();

    const originalTitle = titleElement.getAttribute("data-title");

    const companyWord = companyCount === 1 ? "company" : "companies";
    const jobWord = jobsCount === 1 ? "job" : "jobs";

    titleElement.innerHTML = originalTitle
      .replace("{companies}", companyCount.toLocaleString("en-US"))
      .replace("{jobs}", jobsCount.toLocaleString("en-US"))
      .replace("companies", companyWord)
      .replace("jobs", jobWord);
  }
}

export default PortfolioComponent;
